<script setup lang="ts">
import { computed, useSlots } from 'vue'
import { FairIcon } from '@/ui/primitives/FairIcon'
import type { FairIconName } from '@/ui/tokens/icons.data'
import type { FairRdIconContainerSize } from '@/ui/tokens/redesign.data'

/**
 * Figma Icon container — Media board 1:1462
 * Sizes: 20 / 16 / 12 (default icon glyph scales to container).
 */
interface FairIconContainerProps {
  size?: FairRdIconContainerSize
  /** When set and no default slot, renders FairIcon */
  name?: FairIconName | string
  color?: string
}

const props = withDefaults(defineProps<FairIconContainerProps>(), {
  size: 20,
})

const slots = useSlots()

const hasSlot = computed(() => Boolean(slots.default))
</script>

<template>
  <span
    class="fair-icon-container"
    :class="`fair-icon-container--${size}`"
    aria-hidden="true"
  >
    <slot v-if="hasSlot" />
    <FairIcon
      v-else-if="name"
      :name="name"
      :size="size"
      :color="color"
    />
  </span>
</template>

<style scoped>
.fair-icon-container {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  line-height: 0;
  overflow: hidden;
}
</style>
